import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import { xAxisExtensionInstall } from './xAxis';
import { yAxisExtensionInstall } from './yAxis';
import { actionExtensionInstall } from './action';

export function install(registers: EChartsExtensionInstallRegisters) {
  xAxisExtensionInstall(registers);
  yAxisExtensionInstall(registers);
  actionExtensionInstall(registers);
}
